import { CircularProgress, Collapse, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { RoomtypeForAllocatedList } from '../../types/inventoryAllocatedList'
import AllocateChannelRow from './AllocateChannelRow'
import AllocateRoomtypeRow from './AllocateRoomTypeRow'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface AllocateRoomtypeBoxProps {
  roomData: RoomtypeForAllocatedList
  weekendIndexes: number[]
  propertyCode: string
}

const PAGE_SIZE = 10

const AllocateRoomtypeBox: React.FC<AllocateRoomtypeBoxProps> = ({
  roomData,
  weekendIndexes,
  propertyCode
}) => {
  const classes = useStyles()

  const [showChannels, setshowChannels] = useState(false)

  const [numberOfVisibleRatePlans, setnumberOfVisibleRatePlans] =
    useState(PAGE_SIZE)

  return (
    <Paper className={classes.paper} elevation={5}>
      <div>
        <AllocateRoomtypeRow
          name={`${roomData?.basicDetails.name} (${roomData.basicDetails.displayRoomTypeCode})`}
          pooledAvailability={roomData?.detailsForEachDate.map((date) => ({
            date: date.date,
            value: date.pooledAvailability
          }))}
          totalAvailability={roomData?.detailsForEachDate.map((date) => ({
            date: date.date,
            value: date.totalAvailability
          }))}
          weekendIndexes={weekendIndexes}
          numberOfChannels={roomData.channels.length}
          numberOfRoom={roomData.basicDetails.numberOfRooms}
          setshowChannels={setshowChannels}
          showChannels={showChannels}
        />
        <Collapse in={showChannels}>
          <div>
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setTimeout(() => {
                  setnumberOfVisibleRatePlans(
                    numberOfVisibleRatePlans + PAGE_SIZE
                  )
                }, 500)
              }}
              hasMore={
                roomData &&
                numberOfVisibleRatePlans <= roomData.channels.length - 1
              }
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={true}>
              {roomData.channels
                .slice(0, numberOfVisibleRatePlans)
                .map((channelItem, index) => (
                  <AllocateChannelRow
                    key={index}
                    allocatedAvailability={channelItem.detailsForEachDate.map(
                      (date) => ({
                        date: date.date,
                        value: date.allocatedAvailability
                      })
                    )}
                    channelData={channelItem}
                    weekendIndexes={weekendIndexes}
                    propertyCode={propertyCode}
                    roomtypeCode={roomData.basicDetails.roomtypeCode}
                  />
                ))}
            </InfiniteScroll>
          </div>
        </Collapse>
      </div>
    </Paper>
  )
}

export default AllocateRoomtypeBox
